import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { openEpaycoCheckout } from '@/composables/useEpaycoCheckout'
import { usePaymentService } from '@/services/payment/usePaymentService'

export const useAiCreditsCheckout = () => {
  const route = useRoute()
  const router = useRouter()
  const { createAiCreditPurchase } = usePaymentService()
  const isSubmitting = ref(false)

  const responseUrl = () => {
    const url = new URL(router.resolve({ name: 'checkout.result' }).href, window.location.origin)
    url.searchParams.set('return_to', route.fullPath)
    return url.toString()
  }

  const startCheckout = async (tokenPackageId: string) => {
    if (isSubmitting.value) return false

    isSubmitting.value = true
    try {
      const purchase = await createAiCreditPurchase({
        token_package_id: tokenPackageId,
        pack_count: 1,
        response_url: responseUrl(),
      })

      if (purchase.checkout_type === 'redirect') {
        if (!purchase.checkout_url) throw new Error('No se recibió la URL de pago')
        window.location.href = purchase.checkout_url
        return true
      }

      if (!purchase.checkout_session_id) throw new Error('No se recibió la sesión de pago')

      await openEpaycoCheckout(
        {
          sessionId: purchase.checkout_session_id,
          type: purchase.checkout_type,
          test: false,
        },
        {
          onClosed: () => {
            void router.replace({
              name: 'checkout.result',
              query: { order_id: purchase.order_id, return_to: route.fullPath },
            })
          },
        },
        purchase.checkout_script_url || undefined,
      )

      return true
    } finally {
      isSubmitting.value = false
    }
  }

  return { isSubmitting, startCheckout }
}
